// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".subheading[data-v-4371d06e]{padding:0;font-style:normal;font-weight:900;font-size:20px;line-height:26px;letter-spacing:.015em;margin:0;color:#c6c8cd}@media(min-width:550px){.subheading[data-v-4371d06e]{font-size:24px;line-height:29px;letter-spacing:unset}}.slider[data-v-4371d06e]{margin-top:20px}@media(max-width:480px){.slider[data-v-4371d06e]{margin-inline:-24px}}@media(max-width:480px){article.encounter[data-v-4371d06e]:first-child{margin-inline-start:8px}}", ""]);
// Exports
module.exports = exports;
